import {
  computed,
  onBeforeUnmount,
  onMounted,
  ref,
} from 'vue';

const useToggleState = () => {
  let showMenu = ref(false);
  let refToggleState = ref(null);

  const toggleMenu = () => {
    showMenu.value = !showMenu.value;
  };

  const handleBodyClick = e => {
    if (refToggleState.value && !refToggleState.value.contains(e.target)) {
      showMenu.value = false;
    }
  };

  onMounted(() => {
    document.body.addEventListener('click', handleBodyClick);
  });

  onBeforeUnmount(() => {
    document.body.removeEventListener('click', handleBodyClick);
  });

  return {
    showMenu,
    toggleMenu,
    handleBodyClick,
    refToggleState: computed({
      get: () => refToggleState.value,
      set: value => {
        refToggleState.value = value;
      },
    }),
  };
};

export default useToggleState;
